module.exports = __webpack_public_path__ + "img/FeaturePic1.0d88cc81.png";